import { accounting } from 'accounting';

export function getSelector(a, t) {
  if (a[0] instanceof jQuery) {
    return a[0]
  }
  return $($.type(a[0]) === "string" ? a[0] : t);
}

// Wrapper for $L provided by i18n-asset-pipeline
export function i18n() {
  var t = $L(arguments[0]);

  if (arguments.length > 1) {
    for (var i = 1; i < arguments.length; i++) {
      t = t.replace('{' + (i - 1) + '}', arguments[i]);
    }
  }

  return t !== undefined ? t : arguments[0];
}

export function moneyFormat(amount) {
  return accounting.formatMoney(amount, '<span>&euro;</span> ', 2, '.', ',');
}



// WEBPACK FOOTER //
// ./grails-app/assetsSrc/scripts/utils.js